const setSelectedProduct = (state, payload) => {
  state.selectedProduct = payload;
};

export default {
  setSelectedProduct,
};
